import * as ActionTypes from './index';

export const initMenu = (data) => {
    return {
        type: ActionTypes.INIT_MENU,
        data,
    };
}